import {AbstractStorage} from "./abstract-storage";


export class SessionStorageService extends AbstractStorage {

  protected getStorage(): Storage | undefined {
    return window?.sessionStorage ?? undefined;
  }

}

export const sessionStorageService = new SessionStorageService();
